import axios, { AxiosError, AxiosResponse } from "axios"
import { apiEndpoint } from "../configs/config.constants"

export const httpPost = async (url: string, body: Record<string, unknown>, headers: Record<string, unknown> = {}): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {
    axios.post(`${apiEndpoint}${url}`, body, {
      headers: {
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
        'project-id': localStorage.getItem('project-id'),
        ...headers
      },
    }).then((response: AxiosResponse) => {
      resolve(response)
    }).catch((error: AxiosError) => {
      reject(error)
    })
  })
}

export const httpGet = async (url: string, body: Record<string, unknown> = {}, headers: Record<string, unknown> = {}): Promise<AxiosResponse> => {
  return new Promise((resolve, reject) => {

    if (localStorage.getItem('accessToken')) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('accessToken') as string
    }

    axios.get(`${apiEndpoint}${url}`, {
      params: body,
      headers: {
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'project-id': localStorage.getItem('project-id'),
        ...headers
      },
    }).then((response: AxiosResponse) => {
      resolve(response)
    }).catch((error: AxiosError) => {
      reject(error)
    })
  })
}

export const httpPatch = async (url: string, data: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    axios.patch(`${apiEndpoint}${url}`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
        'project-id': localStorage.getItem('project-id'),
      }
    }).then((response: AxiosResponse) => {
      resolve(response)
    }).catch((error: AxiosError) => {
      reject(error)
    })
  })
}

export const httpPut = async (url: string, data: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    axios.put(`${apiEndpoint}${url}`, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
        'project-id': localStorage.getItem('project-id'),
      }
    }).then((response: AxiosResponse) => {
      resolve(response)
    }).catch((error: AxiosError) => {
      reject(error)
    })
  })
}

export const httpDelete = (url: string) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${apiEndpoint}${url}`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
        'project-id': localStorage.getItem('project-id'),
      }
    }).then((response: AxiosResponse) => {
      resolve(response)
    }).catch((error: AxiosError) => {
      reject(error)
    })
  })
}
